module.exports = __webpack_public_path__ + "img/mine.17f02996.png";